// Dealer Workbench Lotus purchasing-policy check. Reads storefront Liquid
// generated from the same product metafields as the product-page disclosures.
// The app-proxy SKU resolver remains the authority for variant identity.
(() => {
  'use strict';
  if (window.SC_LotusOrderGate) return;

  const cache = new Map();
  const clean = (v) => String(v == null ? '' : v).trim();

  async function fetchPolicy(handle) {
    const id = clean(handle);
    if (!/^[a-z0-9][a-z0-9-]*$/i.test(id)) {
      throw new Error('A product link is missing. Review this SKU on its product page.');
    }
    if (!cache.has(id)) {
      const task = (async () => {
        const response = await fetch('/products/' + encodeURIComponent(id), {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
        });
        if (!response.ok) throw new Error('Could not check Lotus terms for ' + id + '.');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const proof = doc.querySelector('product-info[id^="MainProduct-"] [data-sc-lotus-policy-proof]');
        if (!proof) throw new Error('Lotus policy information is unavailable for ' + id + '.');
        const data = JSON.parse(proof.textContent || '{}');
        if (!Array.isArray(data.overstockSkus) || typeof data.tangraMadeToOrder !== 'boolean') {
          throw new Error('Lotus policy information is incomplete for ' + id + '.');
        }
        return data;
      })();
      cache.set(id, task);
      task.catch(() => cache.delete(id));
    }
    return cache.get(id);
  }

  async function confirmItems(items) {
    if (!Array.isArray(items)) throw new Error('Cannot verify the order items.');
    const notices = [];

    for (const item of items) {
      const vendor = clean(item.vendor);
      const sku = clean(item.sku);
      if (!sku) throw new Error('A SKU is missing. Verify this order before adding it.');
      // An empty vendor is valid for non-Lotus items. Only positively
      // identified Lotus products require the supplier-policy proof.
      if (!vendor.toLowerCase().includes('lotus')) continue;
      const details = await fetchPolicy(item.handle);
      const overstock = details.overstockSkus.some((entry) => clean(entry).toUpperCase() === sku.toUpperCase());
      if (overstock) notices.push(sku + ': OVERSTOCK — FINAL SALE while quantities last. No change-of-mind returns/exchanges; statutory rights unaffected.');
      if (details.tangraMadeToOrder) notices.push(sku + ': TANGRA — made to order in Canada (2-day production lead). Cancellations/revisions after assembly begins incur a 30% restocking fee.');
    }

    if (!notices.length) return true;
    return window.confirm(
      'These order lines have supplier-specific terms:\n\n' +
      notices.join('\n\n') +
      '\n\nSelect OK to accept the terms and add these items to your cart, or Cancel to review the products.'
    );
  }

  window.SC_LotusOrderGate = { confirmItems };
})();
